import React from 'react';

const ReferrerRewardPlanFormModal = React.lazy(() => import('../components/FormModal'));
const referrerRewardPlanModalRegistry = {
    core_referrerRewardPlanId: ReferrerRewardPlanFormModal
};
export default referrerRewardPlanModalRegistry;
